import { createStore } from '@/utils/create-store.ts'

export interface ResultsFilterState {
  hexgridSelectedIds: string[] | null
  timelineSelectedIds: string[] | null

  omittedSources: string[]
  omittedRepos: string[]
  omittedAssets: string[]
  omittedSensors: string[]
  qualityCeil: number | null
  cloudCeil: number | null

  setHexgridSelectedIds: (ids: string[] | null) => void
  setTimelineSelectedIds: (ids: string[] | null) => void

  setOmittedSources: (omittedSources: string[]) => void
  setOmittedRepos: (omittedRepos: string[]) => void
  setOmittedAssets: (omittedAssets: string[]) => void
  setOmittedSensors: (omittedSensors: string[]) => void
  setQualityFloor: (qualityFloor: number | null) => void
  setQualityCeil: (qualityCeil: number | null) => void
  setCloudFloor: (cloudFloor: number | null) => void
  setCloudCeil: (cloudCeil: number | null) => void
  resetPostfilters: () => void
}

const initialState = {
  hexgridSelectedIds: [],
  timelineSelectedIds: null,

  omittedSources: [],
  omittedRepos: [],
  omittedAssets: [],
  omittedSensors: [],
  qualityCeil: null,
  cloudCeil: null,
}
export const useResultsFilterStore = createStore<ResultsFilterState>({
  initialState,
  actions: (set): Partial<ResultsFilterState> => ({
    setHexgridSelectedIds: (ids: string[] | null) =>
      set({ hexgridSelectedIds: ids }),
    setTimelineSelectedIds: (ids: string[] | null) =>
      set({ timelineSelectedIds: ids }),

    setOmittedSources: (omittedSources) => set({ omittedSources }),
    setOmittedRepos: (omittedRepos) => set({ omittedRepos }),
    setOmittedAssets: (omittedAssets) => set({ omittedAssets }),
    setOmittedSensors: (omittedSensors) => set({ omittedSensors }),
    setQualityCeil: (qualityCeil) => set({ qualityCeil }),
    setCloudCeil: (cloudCeil) => set({ cloudCeil }),
    resetPostfilters: () => set(initialState),
  }),
})

export const useSetHexgridSelectedIds = () =>
  useResultsFilterStore((s) => s.setHexgridSelectedIds)
export const useSetTimelineSelectedIds = () =>
  useResultsFilterStore((s) => s.setTimelineSelectedIds)
export const useSetOmittedSources = () =>
  useResultsFilterStore((s) => s.setOmittedSources)
export const useSetOmittedRepos = () =>
  useResultsFilterStore((s) => s.setOmittedRepos)
export const useSetOmittedAssets = () =>
  useResultsFilterStore((s) => s.setOmittedAssets)
export const useSetOmittedSensors = () =>
  useResultsFilterStore((s) => s.setOmittedSensors)
export const useSetQualityCeil = () =>
  useResultsFilterStore((s) => s.setQualityCeil)
export const useSetCloudCeil = () =>
  useResultsFilterStore((s) => s.setCloudCeil)
export const useResetPostfilters = () =>
  useResultsFilterStore((s) => s.resetPostfilters)

export const useOmittedSources = () =>
  useResultsFilterStore((s) => s.omittedSources)
export const useOmittedSensors = () =>
  useResultsFilterStore((s) => s.omittedSensors)
export const useOmittedRepos = () =>
  useResultsFilterStore((s) => s.omittedRepos)
export const useOmittedAssets = () =>
  useResultsFilterStore((s) => s.omittedAssets)
export const useQualityCeil = () => useResultsFilterStore((s) => s.qualityCeil)
export const useCloudCeil = () => useResultsFilterStore((s) => s.cloudCeil)
export const useHexgridSelectedIds = () =>
  useResultsFilterStore((s) => s.hexgridSelectedIds)
export const useTimelineSelectedIds = () =>
  useResultsFilterStore((s) => s.timelineSelectedIds)
